export const ARCHIVE_CREATE_SYSTEM_JOB_NAME = "org.graylog.plugins.archive.job.ArchiveCreateSystemJob";
export const ARCHIVE_LICENSE_WARNING_TITLE = "Archive creation is disabled";
export const ARCHIVE_LICENSE_WARNING_TEXT = "Archive creation is disabled because there is no valid license. You can still restore existing archives, but new ones will not be created.";
